"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddCarExcessWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var VoluntaryExcessWidget_1 = require("./VoluntaryExcessWidget");
var commonFunctions_1 = require("../../../commonFunctions");
var CarExcessChangePopupWidget_1 = require("../../../components/subscription/motor/carExcess/CarExcessChangePopupWidget");
var services_1 = require("@falcon/services");
var AddCarExcessWidget = /** @class */ (function (_super) {
    __extends(AddCarExcessWidget, _super);
    function AddCarExcessWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.renderVehicleExcesses = function (vehicle) {
            if (!vehicle.excesses) {
                vehicle.excesses = {};
            }
            var totalAd = vehicle.excesses.totalAd;
            return (React.createElement("div", null,
                React.createElement("h2", { className: "inner-content font-light" }, "Excess"),
                React.createElement(VoluntaryExcessWidget_1.VoluntaryExcessWidget, __assign({ vehicleIndex: vehicle.info.index, totalAd: totalAd, onSave: _this.handleSave }, _this.props)),
                _this.renderPersonExcesses(vehicle),
                React.createElement("div", { className: "inner-content excess" },
                    React.createElement("b", null, "Windscreen replacement"),
                    React.createElement("b", { className: "amount" },
                        "\u00A3",
                        vehicle.excesses.windscreenReplacementExcess),
                    React.createElement("hr", { "aria-hidden": "true" })),
                React.createElement("div", { className: "inner-content excess" },
                    React.createElement("b", null, "Windscreen repair"),
                    React.createElement("b", { className: "amount" },
                        "\u00A3",
                        vehicle.excesses.windscreenRepairExcess),
                    React.createElement("hr", { "aria-hidden": "true" })),
                React.createElement("div", { className: "inner-content excess" },
                    React.createElement("b", null, "Non recommended repairer"),
                    React.createElement("b", { className: "amount" },
                        "\u00A3",
                        vehicle.excesses.nonRecommendedRepairerExcess),
                    React.createElement("hr", { "aria-hidden": "true" }))));
        };
        _this.handleSave = function (amount) {
            var interaction = _this.props.engine.getInteraction();
            var vehicleExcessChangeIndexes = interaction.uistate.vehicleExcessChangeIndexes.split(",");
            if (amount > 100 && vehicleExcessChangeIndexes.includes("0") && !_this.state.popupShown) {
                _this.setState(function (state) { return ({
                    showPopup: true,
                    popupShown: true
                }); });
            }
        };
        _this.togglePopUp = function () {
            _this.setState(function (state) { return ({
                showPopup: !state.showPopup
            }); });
        };
        _this.state = {
            showPopup: false,
            popupShown: false
        };
        return _this;
    }
    AddCarExcessWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "widget carExcess-widget" },
                React.createElement("div", { className: "plugin plugin-panel" },
                    React.createElement("img", { className: "vehicle-icon", alt: "Vehicle icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-car-icon.png") }),
                    React.createElement("h2", { className: "inner-content center font-light" },
                        this.props.interaction.vehicles[0].make,
                        ", ",
                        this.props.interaction.vehicles[0].model),
                    React.createElement("div", { className: "inner-content center number-plate-preview" }, this.props.interaction.vehicles[0].registrationNumber),
                    React.createElement("hr", { "aria-hidden": "true" }),
                    React.createElement("div", { className: "inner-content excess" },
                        React.createElement("span", null, "Cover start date"),
                        React.createElement("span", { className: "amount" }, (0, commonFunctions_1.convertDate)(this.props.interaction.headerInfo.startDate, "DD MMMM YYYY"))),
                    React.createElement("hr", { "aria-hidden": "true" }),
                    this.renderVehicleExcesses(this.props.interaction.vehicles[0]))),
            React.createElement(CarExcessChangePopupWidget_1.CarExcessChangePopupWidget, { isOpen: this.state.showPopup, toggle: this.togglePopUp })));
    };
    AddCarExcessWidget.prototype.renderPersonExcesses = function (vehicle) {
        var personExcesses = [];
        for (var _i = 0, _a = vehicle.driverIds; _i < _a.length; _i++) {
            var driverId = _a[_i];
            if (this.props.interaction.policyHolder.personId === driverId) {
                personExcesses.push(React.createElement("div", { key: driverId },
                    React.createElement("div", { className: "inner-content excesses" },
                        React.createElement("div", { className: "excessSummary" },
                            React.createElement("b", null,
                                "Breakdown of excess for ",
                                this.props.interaction.policyHolder.firstName,
                                " ",
                                this.props.interaction.policyHolder.lastName))),
                    React.createElement("div", { className: "inner-content excess" },
                        React.createElement("b", null, "Total fire"),
                        React.createElement("b", { className: "amount" },
                            "\u00A3",
                            vehicle.excesses.totalFire)),
                    React.createElement("div", { className: "inner-content excess" },
                        React.createElement("span", null,
                            "(\u00A3",
                            vehicle.excesses.fireExcess,
                            " compulsory + \u00A3",
                            vehicle.excesses.voluntaryExcess,
                            " voluntary)"),
                        React.createElement("hr", { "aria-hidden": "true" })),
                    React.createElement("div", { className: "inner-content excess" },
                        React.createElement("b", null, "Total theft"),
                        React.createElement("b", { className: "amount" },
                            "\u00A3",
                            vehicle.excesses.totalTheft)),
                    React.createElement("div", { className: "inner-content excess" },
                        React.createElement("span", null,
                            "(\u00A3",
                            vehicle.excesses.theftExcess,
                            " compulsory + \u00A3",
                            vehicle.excesses.voluntaryExcess,
                            " voluntary)"),
                        React.createElement("hr", { "aria-hidden": "true" })),
                    React.createElement("div", { className: "inner-content excess" },
                        React.createElement("b", null, "Total accidental damage"),
                        React.createElement("b", { className: "amount" },
                            "\u00A3",
                            vehicle.excesses.totalAd + this.props.interaction.policyHolder.excesses.adExcess)),
                    React.createElement("div", { className: "inner-content excess" },
                        React.createElement("span", null,
                            "(\u00A3",
                            this.props.interaction.policyHolder.excesses.adExcess + vehicle.excesses.adExcess,
                            " compulsory + \u00A3",
                            vehicle.excesses.voluntaryExcess,
                            " voluntary)"),
                        React.createElement("hr", { "aria-hidden": "true" }))));
            }
            if (this.props.interaction.additionalDrivers && this.props.interaction.additionalDrivers.length > 0) {
                for (var _b = 0, _c = this.props.interaction.additionalDrivers; _b < _c.length; _b++) {
                    var additionalDriver = _c[_b];
                    if (additionalDriver.personId === driverId) {
                        personExcesses.push(React.createElement("div", { key: driverId },
                            React.createElement("div", { className: "inner-content excesses" },
                                React.createElement("div", { className: "excessSummary" },
                                    React.createElement("b", null,
                                        "Breakdown of excess for ",
                                        additionalDriver.firstName,
                                        " ",
                                        additionalDriver.lastName))),
                            React.createElement("div", { className: "inner-content excess" },
                                React.createElement("b", null, "Total fire"),
                                React.createElement("b", { className: "amount" },
                                    "\u00A3",
                                    vehicle.excesses.totalFire)),
                            React.createElement("div", { className: "inner-content excess" },
                                React.createElement("span", null,
                                    "(\u00A3",
                                    vehicle.excesses.fireExcess,
                                    " compulsory + \u00A3",
                                    vehicle.excesses.voluntaryExcess,
                                    " voluntary)"),
                                React.createElement("hr", { "aria-hidden": "true" })),
                            React.createElement("div", { className: "inner-content excess" },
                                React.createElement("b", null, "Total theft"),
                                React.createElement("b", { className: "amount" },
                                    "\u00A3",
                                    vehicle.excesses.totalTheft)),
                            React.createElement("div", { className: "inner-content excess" },
                                React.createElement("span", null,
                                    "(\u00A3",
                                    vehicle.excesses.theftExcess,
                                    " compulsory + \u00A3",
                                    vehicle.excesses.voluntaryExcess,
                                    " voluntary)"),
                                React.createElement("hr", { "aria-hidden": "true" })),
                            React.createElement("div", { className: "inner-content excess" },
                                React.createElement("b", null, "Total accidental damage"),
                                React.createElement("b", { className: "amount" },
                                    "\u00A3",
                                    additionalDriver.excesses.adExcess + vehicle.excesses.totalAd)),
                            React.createElement("div", { className: "inner-content excess" },
                                React.createElement("span", null,
                                    "(\u00A3",
                                    additionalDriver.excesses.adExcess + vehicle.excesses.adExcess,
                                    " compulsory + \u00A3",
                                    vehicle.excesses.voluntaryExcess,
                                    " voluntary)"),
                                React.createElement("hr", { "aria-hidden": "true" }))));
                    }
                }
            }
        }
        return personExcesses;
    };
    return AddCarExcessWidget;
}(plugin_journey_1.WidgetBase));
exports.AddCarExcessWidget = AddCarExcessWidget;
//# sourceMappingURL=AddCarExcessWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/AddCarExcessWidget.js
// module id = 2590
// module chunks = 0